export const ScrapeFragment = gql`
  fragment ScrapeFragment on Scrape {
    uuid
    status
    startedAt
    completedAt
    failedAt
    failedReason
    progress {
      pagesFound
      pagesScraped
      pagesAITrained
      documentsCount
    }
  }
`
